var expandTiles = false;
var tracker = false;

if(typeof(Storage) === "undefined") {
	alert('This browser does not support web storage.');
    // Sorry! No Web Storage support..
}
// localStorage.clear();

var app = angular.module('sog', ['infinite-scroll','ngRoute','angulartics','angulartics.google.analytics']);